import React from 'react';
import { Routes, Route } from 'react-router-dom';
import MainUploadPage from './pages/MainUploadPage';
import ConfluenceTargetPage from './pages/ConfluenceTargetPage';
import ProjectDetailsPage from './pages/ProjectDetailsPage';
import ProjectStoryQaPage from './pages/ProjectStoryQaPage';
import ProjectTestCasesPage from './pages/ProjectTestCasesPage';
import ProjectChecklistPage from './pages/ProjectChecklistPage';
import ProjectSummaryReportPage from './pages/ProjectSummaryReportPage';
import AdminUsersPage from './pages/AdminUsersPage';
import AdminLicenseWorkbenchPage from './pages/AdminLicenseWorkbenchPage';
import LoginPage from './pages/LoginPage';
import InitialPasswordSetupPage from './pages/InitialPasswordSetupPage';
import { AuthProvider, RequireAuth } from './auth/AuthContext';
import AppLayout from './components/AppLayout';

function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/initial-password" element={<InitialPasswordSetupPage />} />
        <Route element={<RequireAuth />}>
          <Route element={<AppLayout />}>
            <Route path="/*" element={<MainUploadPage />} />
            <Route path="/:pageId" element={<ConfluenceTargetPage />} />
            <Route path="/projects/:id" element={<ProjectDetailsPage />} />
            <Route path="/projects/:id/story-qa" element={<ProjectStoryQaPage />} />
            <Route path="/projects/:id/test-cases" element={<ProjectTestCasesPage />} />
            <Route path="/projects/:id/checklist" element={<ProjectChecklistPage />} />
            <Route path="/projects/:id/summary-report" element={<ProjectSummaryReportPage />} />
            <Route path="/admin/users" element={<AdminUsersPage />} />
            <Route path="/internal/a9f3-license-workbench" element={<AdminLicenseWorkbenchPage />} />
          </Route>
        </Route>
      </Routes>
    </AuthProvider>
  );
}

export default App;
